/**
 * Pure helpers for the "What TDIA checked" tab (DEC-189), kept out of the component file
 * so the page and the tests can share them.
 */
import { AGENT_CATEGORY_CODE, AGENT_LABELS } from '../../types/api'

export function agentName(agentId: string): string {
  return AGENT_LABELS[agentId] ?? agentId
}

/** The categories an agent's findings are filed under. One per agent today. */
export function agentCategories(agentId: string): string[] {
  const code = AGENT_CATEGORY_CODE[agentId]
  return code ? [code] : []
}

export function plural(n: number, one: string, many: string): string {
  return n === 1 ? one : many
}

/**
 * "F found something, C were clean, R could not run. A did not apply, and B are not
 * built yet." The first three sum to the headline; the last two are named after it and
 * never mixed into it, which is what the old summary line did.
 */
export function checkedSentence(counts: {
  found: number
  clean: number
  notRun: number
  notApplicable: number
  notBuilt: number
}): string {
  const { found, clean, notRun, notApplicable, notBuilt } = counts
  return (
    `${found} found something, ${clean} ${plural(clean, 'was', 'were')} clean, ` +
    `${notRun} could not run. ${notApplicable} did not apply, and ${notBuilt} ` +
    `${plural(notBuilt, 'is', 'are')} not built yet.`
  )
}
